// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter-active[data-v-cefee02c]{opacity:0;transition:.3s ease-in-out}.fade-enter-to[data-v-cefee02c]{opacity:1}.fade-leave-active[data-v-cefee02c]{opacity:1;transition:.3s ease-in-out}.fade-leave-to[data-v-cefee02c]{opacity:0}.data-provider[data-v-cefee02c]{color:#000}.data-provider p[data-v-cefee02c]{margin-bottom:.25rem}.data-provider .provider-link[data-v-cefee02c]{font-weight:600}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
